/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

import type { Case, CaseEntity, CaseRelation } from '@/types/trpc/case';
import { CaseType } from '~/common/enums';
import type { SalesCaseData } from '~/common/types/case/case';

type CaseContextType = {
  canEditCase: boolean;
  caseEntities: CaseEntity[];
  caseType: CaseType | undefined;
  currentCase: Case | undefined;
  ownRelation: CaseRelation | undefined;
  refetchCase: () => void;
  refetchCaseEntities: () => void;
  refetchSalesCaseData: () => void;
  salesCaseData?: SalesCaseData;
};

export const CaseContext = createContext({
  canEditCase: false,
  caseEntities: [],
  caseType: CaseType.Case,
  currentCase: {} as Case,
  ownRelation: {} as CaseRelation,
  refetchCase: () => { },
  refetchCaseEntities: () => { },
  refetchSalesCaseData: () => { },
  salesCaseData: undefined,
} as CaseContextType);
